import swal from 'sweetalert';

function errorBag(errors) {
    let errormessages = '';

    if (typeof errors.errors === 'undefined' || errors.errors === null || errors.errors === undefined || errors.errors === '') {
        if (typeof errors.error !== 'undefined' && errors.error !== null && errors.error !== undefined && errors.error !== '') {
            if (typeof errors.error.message !== 'undefined' && errors.error.message !== null && errors.error.message !== undefined && errors.error.message !== '') {
                errormessages = errors.error.message;
                return errormessages;
            }
        }

        if (typeof errors.message !== 'undefined' && errors.message !== null && errors.message !== undefined && errors.message !== '') {
            errormessages = errors.message;
            return errormessages;
        }

        return errormessages;
    }

    Object.keys(errors.errors).forEach(field => {
        Object.keys(errors.errors[field]).forEach(err => {
            errormessages += `- ${errors.errors[field][err]} ${'\n'}`;
        });
    });

    return errormessages;
}

export { errorBag };

function handleError(object) {
    const { error, message } = object;
    let { progress } = object;

    if (!progress) {
        progress = true;
    }

    if (progress) {
        NProgress.done();
    }

    console.error(error);

    if (!error.response) return;

    swal({
        title: message,
        text: errorBag(error.response.data),
    });
}

export default handleError;
